import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=18b168a1&scoped=true"
import script from "./Overall.vue?vue&type=script&lang=js"
export * from "./Overall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b168a1",
  null
  
)

export default component.exports